export default __webpack_public_path__ + "static/media/home-decor-img-04.e351ffe8.jpg";